import { chipClasses, styled } from "@mui/material";
import { Chip } from "../../Chip/index.js";
import { tagName } from "../classes.js";
const SIZE = 20;
const Root = styled(Chip, {
  name: tagName,
  slot: "Root",
  overridesResolver: (_props, styles) => [styles.root]
})(({ ownerState, theme }) => {
  const mode = ownerState?.mode ?? "squared";
  return {
    paddingLeft: theme.spacing(mode === "squared" ? 0 : 0.25),
    paddingRight: theme.spacing(mode === "squared" ? 0 : 0.25),
    height: `${SIZE}px`,
    borderRadius: mode === "squared" ? theme.spacing(0.5) : void 0,
    [`& .${chipClasses.icon}`]: {
      fontSize: "1rem",
      marginLeft: theme.spacing(0.5),
      marginRight: 0
    },
    [`& .${chipClasses.label}`]: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    }
  };
});
export {
  Root
};
//# sourceMappingURL=Root.js.map
